(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/carousel/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tb-ui/carousel/assets/javascripts/utils.js');

'use strict';

const DragState = Object.freeze({
  START: 'drag-start',
  DRAGGING: 'drag-active',
  END: 'drag-end',
  IDLE: 'drag-idle'
});
const MouseEvents = Object.freeze({
  START: 'mousedown',
  MOVE: 'mousemove',
  STOP: 'mouseup'
});
const TouchEvents = Object.freeze({
  START: 'touchstart',
  MOVE: 'touchmove',
  STOP: 'touchend'
});
const supportsTouch = () => {
  if ('ontouchstart' in window) {
    return true;
  }

  if (window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }
  return window.matchMedia('(pointer: coarse)').matches;
};
const calculateScrollbarWidth = () => {
  const el = document.createElement('div');
  el.style = 'overflow:scroll;position:absolute;top:-99999px;width:100px;';
  document.body.appendChild(el);
  const diff = el.offsetWidth - el.clientWidth;
  el.remove();
  return diff;
};
setGlobal('svs.components.tbUi.carousel.utils', {
  calculateScrollbarWidth,
  DragState,
  MouseEvents,
  TouchEvents,
  supportsTouch
});

 })(window);